"use strict";

export function initInScope ($scope) {

    $scope.find('.js-navbar-toggle').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);

        if($this.hasClass('is-open')){
            $this.removeClass('is-open');
            $('body').removeClass('nav-open');

        }else{
            $this.addClass('is-open');
            $('body').addClass('nav-open');
        }
    });

    if(matchMedia('(max-width: 767px)').matches){
        $scope.find('.js-navbar-toggle__subnav').on('click', function (e) {
            e.preventDefault();

            let $thisLi = $(this).closest('li');

            if($thisLi.hasClass('is-open')){
                $thisLi.removeClass('is-open');
            }else{
                $thisLi.addClass('is-open');
            }

        });

    }

    if (matchMedia('(min-width: 768px)').matches) {
        // Open on focusin of the toggle link
        $scope.on('focusin', '.js-nav .js-nav__item__toggle', function () {
            const $toggle = $(this);
            const $li = $toggle.closest('li');
            $li.addClass('is-open');
            if ($toggle.attr('aria-controls')) {
                $toggle.attr('aria-expanded', 'true');
            }
        });

        $scope.on('focusout', '.js-nav .js-nav__item', function (e) {
            const $li = $(this);
            const rt = e.relatedTarget;
            if (rt && $li.has(rt).length) return; // still inside, keep open

            setTimeout(function () {
                const active = document.activeElement;
                if (!$li.has(active).length) {
                    $li.removeClass('is-open');
                    const $toggle = $li.find('.js-nav__item__toggle[aria-expanded="true"]');
                    if ($toggle.length) {
                        $toggle.attr('aria-expanded', 'false');
                    }
                }
            }, 0);
        });
    }

    $scope.on('keydown', '.js-nav .is-open', function (e) {
        const key = e.key || e.keyCode;
        if (key === 'Escape' || key === 'Esc' || key === 27) {
            const $li = $(e.target).closest('li.is-open');
            if ($li.length) {
                $li.removeClass('is-open');
                const $toggle = $li.find('.js-nav__item__toggle[aria-expanded="true"]');
                if ($toggle.length) {
                    $toggle.attr('aria-expanded', 'false');
                }
                const $nextLi = $li.nextAll('li').first();
                const $targetLi = $nextLi.length ? $nextLi : $li.parent().children('li').first();
                let $focusTarget = $targetLi.find('.js-nav__item__toggle').first();
                if (!$focusTarget.length) {
                    $focusTarget = $targetLi.find('a.nav-link').first();
                }
                if ($focusTarget.length) {
                    $focusTarget.focus();
                }
            }
            e.stopPropagation();
        }
    });
}

